module.exports = __webpack_public_path__ + "static/media/2-it.aed58990.png";